export default __webpack_public_path__ + "static/media/leaf-co2.5d78862e.svg";